import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getExportCandidateData } from "../../../redux/slice/getExportCandidateDataSlice";
import { toast, ToastContainer } from "react-toastify";
import { useHasPermission } from "hooks/useHasPermission";

const CandidateReportPage = () => {
  const dispatch = useDispatch();
  const canViewExportCandidate = useHasPermission("Export Employee Data-view");
  const [isOpen, setIsOpen] = useState(true);
  const [exportStatus, setExportStatus] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState({
    label: "Total Candidate",
    key: null,
  });
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const candidateTypes = [
    { label: "Total Candidate", key: null },
    { label: "Pending", key: "PENDING" },
    { label: "Partial Completed", key: "PARTIAL_COMPLETED" },
    { label: "Completed", key: "COMPLETED" },
    { label: "Back For Revision", key: "SENT_BACK_FOR_REVISION" },
    { label: "Verified", key: "VERIFIED" },
    { label: "Rejected", key: "REJECTED" },
    { label: "Approved", key: "APPROVED" },
  ];

  const handleExport = async () => {
    if (!canViewExportCandidate) {
      toast.error("You don't have permission to export data", {
        className: "toast-error-custom",
        autoClose: 5000,
      });
      return;
    }

    const payload = {
      candidateExportType:
        selectedFilter.label === "Total Candidate" ? null : selectedFilter.key,
      duration: {
        from: fromDate ? `${fromDate}T00:00:00` : null,
        to: toDate ? `${toDate}T23:59:59` : null,
      },
    };

    console.log("candidateExportPayload", payload);
    try {
      await dispatch(getExportCandidateData(payload)).unwrap();
    } catch (error) {
      console.error("Export failed:", error);
    }
  };

  return (
    <div className="container w-100 py-4">
      <div className="p-3 shadow-sm rounded border bg-white w-100">
        <div className="row g-3 align-items-center">
          <div className="col-12 col-lg-4">
            <Dropdown className="w-100">
              <Dropdown.Toggle
                variant="light"
                className="border-0 shadow w-100 d-flex justify-content-between align-items-center"
                style={{ backgroundColor: "#dae0e5", color: "black" }}
                id="dropdown-employee-type"
              >
                <span className="text-truncate pe-2">
                  {selectedFilter.label}
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="shadow border-0 w-100"
                style={{ borderRadius: "10px" }}
              >
                {candidateTypes.map((type, index) => (
                  <Dropdown.Item
                    key={index}
                    onClick={() => setSelectedFilter(type)}
                  >
                    {type.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <div className="col-12 col-md-6 col-lg-auto d-flex align-items-center gap-2">
            <label
              className="fw-bold mb-0 text-nowrap"
              style={{ color: "#333" }}
            >
              From:
            </label>
            <input
              type="date"
              className="form-control shadow-sm border-0 w-100"
              style={{ backgroundColor: "#f8f9fa" }}
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="col-12 col-md-6 col-lg-auto d-flex align-items-center gap-2">
            <label
              className="fw-bold mb-0 text-nowrap"
              style={{ color: "#333" }}
            >
              To:
            </label>
            <input
              type="date"
              className="form-control shadow-sm border-0 w-100"
              style={{ backgroundColor: "#f8f9fa" }}
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <div className="col-12 col-lg-auto ms-lg-auto text-end">
            <button
              className="primary-btn btn btn-primary px-4 py-2 shadow-sm w-100"
              onClick={handleExport}
            >
              Export
            </button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default CandidateReportPage;
